<template>
    <li
        class="aup-text-label"
        :class="{
            'aup-text-label--white': color == 'white',
            'aup-text-label--orange': color == 'orange',
			'aup-text-label--black': color == 'black',
            'aup-text-label--light': color == 'light',
			'aup-text-label--inverted' : inverted == true,
			'aup-text-label--rounded' : rounded == true
        }"
    >
        <p
			class="t-heavy m-0 t-micro text-center"
			:class="{
				'text-uppercase' : uppercase == true,
				'text-capitalize' : uppercase == false,
				't-micro--regular' : bold == false
			}"
		>error:call:42</p>
    </li>
</template>
<script>
export default {
    name: 'BaseTextLabel',
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: 'gray',
        },
        inverted: {
            type: Boolean,
            default: false,
		},
		rounded: {
			type: Boolean,
			default: true,
		},
		uppercase: {
			type: Boolean,
			default: true,
		},
		bold: {
			type: Boolean,
			default: true,
		}
    },
};
</script>

<style lang="scss">
@import '../../assets/scss/all';
.aup-text-label {
    display: flex;
    align-items: center;
    background-color: $gray-300;
    color: $gray-800;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 12px;
    padding-right: 12px;
    list-style: none;
    margin-right: 8px;
    justify-content: center;
    margin-bottom: 12px;

	&--rounded {
        border-radius: 50px;
        padding-bottom: 3px;
	}

    &--inverted {
        background-color: $gray-700;
        color: $gray-300;
    }

    p {
        line-height: 1;
    }

    // &:first-child {
    //     margin-right: 0;
    //     @include media-breakpoint-down(md) {
    //         margin-right: 0.5rem;
    //     }
    // }

    &--white {
        background-color: $sony-white;
        color: $sony-black;
	}

	&--black {
        background-color: $sony-black;
        color: $sony-white;
    }

    &--orange {
        background-color: $primary;
        color: $sony-white;
    }

    &--light {
        background-color: $gray-100;
        color: $black;
    }
}
</style>
